import React, { useEffect, useState } from "react";
import DataTable from 'react-data-table-component';
import { fetchAllPrivilege, fetchControlListByPrivilege, updateControlListByPrivilege } from "../../../resources/PrivilegeResource";
import { showSuccessToast } from "../../../utils/GlobalToast";
import { getLocalAuth } from "../../../utils/AuthUtils";
import ErrorNotFound from "../../errors/Error";

function AccessControlList() {
  const values = getLocalAuth()
  const privilege = JSON.parse(values.authPrivilege);

  let dataPrivilegeDetail = privilege.data.menu.filter(data => {
    return data.code === "Access Control List"
  });

  let dataRead = dataPrivilegeDetail.length === 0 ? [] : dataPrivilegeDetail[0].action_page.filter(data => {
    return data.code === "Read"
  });

  let dataUpdate = dataPrivilegeDetail.length === 0 ? [] : dataPrivilegeDetail[0].action_page.filter(data => {
    return data.code === "Update"
  });

  const [dataPrivilege, setPrivilege] = useState([]);
  const [dataControlListPrivilege, setControlListPrivilege] = useState([]);
  const [privilegeId, setPrivilegeId] = useState(1);

  const [isErrorSave, setIsErrorSave] = useState(false);
  const [errorSave, setErrorSave] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const [showSaveModal, setShowSaveModal] = useState(false);

  const fetchPrivilege = () => {
    fetchAllPrivilege()
      .then((res) => {
        setPrivilegeId(res.data[0].id)
        setPrivilege(res.data);
      })
      .catch((err) => {
        setPrivilege([]);
      });
  };

  const fetchControlListPrivilege = (id) => {
    fetchControlListByPrivilege(id)
      .then((res) => {
        setControlListPrivilege(res.data.menu);
      })
      .catch((err) => {
        setControlListPrivilege([]);
      });
  };

  useEffect(() => {
    fetchPrivilege();
    setTimeout(() => {
      fetchControlListPrivilege(privilegeId);
    }, 500);

    // eslint-disable-next-line
  }, []);

  const handleSave = () => {
    let action_page = [];
    let filter = dataControlListPrivilege.map(data => {
      return {
        id: data.id,
        name: data.name,
        code: data.code,
        action_page: data.action_page.filter(item => {
          // eslint-disable-next-line
          return item.is_active == true;
        })
      }
    });
    for (let i = 0; i < filter.length; i++) {
      if (filter[i].action_page.length !== 0) {
        for (let j = 0; j < filter[i].action_page.length; j++) {
          action_page.push(filter[i].action_page[j].id)
        }
      }
    }

    setIsLoading(true);
    updateControlListByPrivilege(privilegeId, action_page).then((res) => {
      setIsLoading(false);
      setIsErrorSave(false);
      showSuccessToast("Success Saved Control List!");
      setShowSaveModal(false);
      fetchControlListByPrivilege(privilegeId);
    }).catch((err) => {
      setIsLoading(false);
      setErrorSave(err);
      setIsErrorSave(true);
    });

  }

  const onChangeHandlerPrivilege = (e) => {
    const index = e.target.selectedIndex;
    const el = e.target.childNodes[index];
    const option = el.getAttribute("id");
    setPrivilegeId(option);

    fetchControlListPrivilege(option);
  };

  const handleCheckboxChange = (id) => {
    var updatedCheckboxData = dataControlListPrivilege.map((data) => {
      return {
        id: data.id,
        name: data.name,
        code: data.code,
        action_page: data.action_page.map((checkbox) => checkbox.id === id
          ? { ...checkbox, is_active: !checkbox.is_active }
          : checkbox)
      };
    });
    setControlListPrivilege(updatedCheckboxData);
  };

  const columns = [
    {
      name: 'No',
      cell: (row, index) => index + 1,
      width: '60px'
    },
    {
      name: 'Name',
      selector: row => row.name,
      sortable: true,
    },
    {
      name: 'Action Page',
      selector: row => row.action_page.map((data) => {
        return (
          <div className="mt-1 mb-1" key={data.id}>
            <input onChange={(e) => handleCheckboxChange(
              data.id
            )} className="form-check-input me-2" type="checkbox" key={data.id} value={data.id} id={data.id} checked={data.is_active} />
            <label className="form-check-label">{data.name}</label>
          </div>
        );
      }),
      sortable: true,
    },
  ];

  return (
    <div>
      {dataRead.length === 0 ? <ErrorNotFound /> : !dataRead[0].is_active ? <ErrorNotFound /> :
        <div className="page-content-wrapper">
          <div className="page-content">
            <div className="card">
              <div className="card-body">
                <div className="card-title">
                  <div className="row gy-3">
                    <div className="col-md-10">
                      <h4 className="mb-0">Access Control List</h4>
                    </div>
                    <div className="col-md-2 text-end d-grid">
                      {dataUpdate.length === 0 ? <div></div> : !dataUpdate[0].is_active ? <div></div> : <button type="button" className="btn btn-info ms-auto" onClick={() => {
                        setShowSaveModal(true);
                      }}>Save Change</button>}
                      <div className={`modal fade ${showSaveModal ? 'show' : ''}`} style={{ display: showSaveModal ? 'block' : 'none', backgroundColor: 'rgba(0, 0, 0, 0.1)' }}>
                        <div className="modal-dialog">
                          <div className="modal-content">
                            <div className="modal-header">
                              <h5 className="modal-title">Save Change</h5>
                              <button type="button" className="btn-close" onClick={() => setShowSaveModal(false)} aria-label="Close"></button>
                            </div>
                            {isErrorSave ? <div style={{ paddingLeft: '16px', paddingRight: '16px', paddingTop: '16px', paddingBottom: '0px' }}>
                              <div className="alert alert-danger alert-dismissible fade show" role="alert">{errorSave}
                                <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close" onClick={() => setIsErrorSave(false)}></button>
                              </div>
                            </div> : null}
                            <div className="modal-body" style={{ textAlign: 'start' }}>You will change access control list</div>
                            <div className="modal-footer">
                              <button type="button" className="btn btn-secondary" onClick={() => setShowSaveModal(false)}>Cancel</button>
                              {!isLoading ? <button type="submit" className="btn btn-info" onClick={() => handleSave()}>Save</button> :
                                <button className="btn btn-info" type="button" disabled> <span style={{ marginRight: '4px' }} className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                  Loading...</button>}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <hr />
                <div className="row">
                  <div className="col-md-3">
                    <label className="form-label">Privilege :</label>
                    <select className="form-select mb-3" aria-label="Default select example"
                      value={privilegeId}
                      onChange={(e) => onChangeHandlerPrivilege(e)}>
                      {
                        dataPrivilege.map((data) => {
                          return (<option id={data.id}
                            key={data.id}
                            value={data.id}>{data.name}</option>);
                        })
                      }
                    </select>
                  </div>
                </div>
                <br />
                <div className="table-responsive">
                  <DataTable
                    columns={columns}
                    data={dataControlListPrivilege}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  )
}

export default AccessControlList